// DnD, events, and context menu wiring for TaskItemBase controller.
import {
  buildMergedEventHandlers,
  resolveShowRowDelete,
  resolveIsSchedulable,
} from './useTaskItemBaseController.helpers';
import { useTaskItemEvents } from '@/features/tasks/hooks/ui/use-task-item-events.js';
import { useTaskItemContextMenu } from '@/features/tasks/components/context-menu/useTaskItemContextMenu';
import {
  useTaskItemLocalCompleted,
  useTaskItemSortableSetup,
} from './useTaskItemBaseController.hooks';

export function useTaskItemBaseInteraction({
  task,
  isRollup,
  view,
  dragEnabled,
  listId,
  dragType,
  indentationType,
  variant,
  menuSurface,
  tasksMap,
}) {
  const [localCompleted, setLocalCompleted] = useTaskItemLocalCompleted(task);
  const isSchedulable = resolveIsSchedulable(task, tasksMap);
  const {
    isDragDisabled,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
  } = useTaskItemSortableSetup({
    task,
    isRollup,
    view,
    dragEnabled,
    listId,
    dragType,
    isSchedulable,
    indentationType,
    variant,
  });

  const { eventHandlers, isTouchDevice } = useTaskItemEvents({
    task,
    attributes,
    listeners,
  });
  const { menuState, handleContextMenu, closeMenu } = useTaskItemContextMenu({
    menuSurface,
  });
  const mergedEventHandlers = buildMergedEventHandlers(
    eventHandlers,
    handleContextMenu,
    task,
  );
  const showRowDelete = resolveShowRowDelete(menuSurface);

  return {
    localCompleted,
    setLocalCompleted,
    isDragDisabled,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
    isTouchDevice,
    mergedEventHandlers,
    showRowDelete,
    menuState,
    closeMenu,
  };
}
